import { Component } from "react";
import BoardContainer from "./board/BoardContainer";
import { Board } from "src/pods/ideas/data/types";
import logEvent from "src/utils/logEvent";

export type IdeasRemoteProps = {
  selectedBoard: Board;
};

// eslint-disable-next-line react-prefer-function-component/react-prefer-function-component
export default class IdeasRemote extends Component<IdeasRemoteProps> {
  componentDidMount() {
    logEvent({
      eventName: "ideas.setup.open",
    });
  }

  componentWillUnmount() {
    logEvent({
      eventName: "ideas.setup.close",
    });
  }

  /**
   * @return {ReactElement}
   */
  render() {
    const { selectedBoard } = this.props;

    return <BoardContainer board={selectedBoard} />;
  }
}
